<template>
	<div class="container pingjia" v-if="list.length >0">
			<div class="panel panel-default">
				<div class="panel-heading">

					<div class="category">
            <div class="left">
                    <a class="category-top">{{name}}</a>
                    <a class="category-bottom">{{enname}}</a>
                </div>
                <div class="right tip">
                    欢迎点击评分
                </div>
					</div>
				</div>
				<div class="panel-body" style="padding:0px 5px;padding-bottom:10px;max-height:500px;">
					<van-row v-for="(item, index) in list" class="list_g" >
					  <van-col span="6">{{item.name}}</van-col>
					  <van-col span="18">
					  	<van-rate
							  v-model="item.point"
							  :size="16"
							  :count="10"
							  color="rgb(218 53 25)"
							  void-icon="star"
							  void-color="#eee"
							  @change="onChange(item, index)"
							  :readonly="item.readonly"
							/>
					  </van-col>
					</van-row>
					<van-row class="list_g colors">
					  <van-col span="6" v-html="'总  &nbsp;评  &nbsp;分'"></van-col>
					  <van-col span="18">
					  	<van-rate
							  v-model="all"
							  :size="16"
							  :count="10"
							  color="rgb(218 53 25)"
							  void-icon="star"
							  void-color="rgb(210 204 204)"
							  readonly
							/>
					  </van-col>
					</van-row>
					<div v-if="show" style="text-align:center;"><van-button @click="tijiao" type="info" color="rgb(7,148,194)">提交</van-button></div>


				</div>
			</div>
    </div>
</template>
<script>
import {addPingjia} from '../../api/travel'
export default {
  data(){
    return {
      value: 3,
      show: false,
      all: 0
    }
  },
  props: {
  	list: {
  		type: Array||Object,
  		require: true
  	},
  	info: {
  		type: Object,
  		require: true
  	},
  	name: {
  		type: String,
  		default: '游客评价'
  	},
  	total: {
  		type: Number,
  		default: 0
  	},
  	enname: {
  		type: String,
  		default: 'Tourist Evaluation'
  	}
  },
  watch: {
  	total(val){console.log(val)
  		this.all = val
  	}
  },
  components: {  },
  mounted: function () {
  },
  created(){
    this.all = this.total;
  },
  methods: {
  	onChange(item, index){
  		if(!this.info.hasOwnProperty('id')) {
  			this.$toast('信息错误')
  			return
  		}
  		let data = {
  			type: item.name,
  			item_id: this.info.id,
  			item_type: this.info.type,
  			DicNO: this.info.DicNO,
  			point: item.point,
  		}
  		this.$toast.loading({
				  message: '加载中...',
				  forbidClick: true,
			});
  		addPingjia(data).then(res=>{
  			this.$toast.clear()
  			this.$toast('评价成功')
  			let list = this.list
  			list[index]['readonly'] = true
  			this.list = list
  			this.pingjun()
  		})
  	},
  	pingjun(){
  		let total = 0
  		for (let i in this.list) {
  			total += parseInt(this.list[i]['point'])
  		}
  		this.all =  total/this.list.length
  	}
  }
};

</script>
<style scoped>
	.list_g:first-child{
		margin-top: 6px;
	}
	.list_g{
		background-color: #fbfbfb;
		box-shadow: 0 1px 4px rgba(0, 0, 0, 0.4);
		padding: 4px;
		border-radius: 6px;
		display: flex;
		align-items: center;
		width: 90%;
		margin: 0 auto;
		margin-bottom: 6px;
		font-size: 12px;
		font-weight: bold;
		color: #191919;
	}
	.colors{
		background-color: #ffe4db;
	}
	.van-col--6{
		width: auto;
		margin-right: 2%;
	}
</style>